import React, { PureComponent } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { Logo } from ".";
import { SocialList } from "../components";
import { withRedux } from "../hoc";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class Footer extends PureComponent {
  render() {
    const { t } = this.props;
    return (
      <footer>
        <div className="container">
          <div className="row">
            <ul className="col-6 col-md-3 order-1 order-md-1">
              <li>
                <div className="logo">
                  <Logo color="white" />
                </div>
              </li>
            </ul>
            <ul className="col-md-3 order-3 order-md-2">
              <li>
                <Link to="/">{t("Home")}</Link>
              </li>
              <li>
                <Link to="/service">{t("Service")}</Link>
              </li>
              <li>
                <Link to="/about">{t("About Us")}</Link>
              </li>
            </ul>
            <ul className="col-md-3 order-4 order-md-3">
              <li>
                <Link to="/product">{t("Products")}</Link>
              </li>
              <li>
                <Link to="/tips-trends">{t("Tips & Trends")}</Link>
              </li>
            </ul>
            <ul className="col-6 col-md-3 order-2 order-md-4">
              <li>
                <SocialList />
              </li>
              <li>
                <Link to="/contact#contact">{t("Contact Us")}</Link>
              </li>
              <li>
                <Link to="/contact#careers">{t("Careers")}</Link>
              </li>
              <li>
                <Link to="/contact#maps">{t("Maps")}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright-text">{t("© 2018 KKC BEARING SERVICE CO., LTD")}</div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js